module.exports = __webpack_public_path__ + "img/vg.fe6974b2.svg";